<main class="container-lg px-0 py-2">
  <div *ngIf="promoUrl; else noUrl">
    <iframe [src]="promoUrl" width="100%" height="750px" title="account/promo"></iframe>
  </div>
</main>

<ng-template #noUrl>
  <div class="container text-center py-5">
    <h3>{{'ACCOUNT.NOLINK_MESSAGE' | translate}}</h3>
    <h4>{{'ACCOUNT.NOLINK_TIP' | translate}}</h4>
  </div>
</ng-template>

<!--  TODO if we want to show our own promotions instead of iframe-->
<!--<main class="container-lg px-0 pt-3 pb-3 pb-lg-5">-->
<!--  <h2 *ngIf="user"> {{ 'ACCOUNT.WELCOME_MESSAGE' | translate : {username: user.fname} }}</h2>-->
<!--  <h2 *ngIf="!isLoading"> {{ 'ACCOUNT.PROMO.MESSAGE' | translate : {number: promotions.length} }}</h2>-->
<!--  <div *ngIf="isLoading" class="spinner-border" role="status">-->
<!--    <span class="visually-hidden">Loading...</span>-->
<!--  </div>-->
<!--  <div *ngIf="promotions.length" class="container">-->
<!--    <table class="table">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        <th scope="col">#Id</th>-->
<!--        <th scope="col">Name</th>-->
<!--        <th scope="col">State</th>-->
<!--        <th scope="col">Details</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr *ngFor="let p of promotions">-->
<!--        <th scope="row">{{p.id}}</th>-->
<!--        <td>{{p.name}}</td>-->
<!--        <td>{{p.state}}</td>-->
<!--        <td>{{p.details}}</td>-->
<!--      </tr>-->
<!--      </tbody>-->
<!--    </table>-->
<!--  </div>-->
<!--</main>-->
